module.exports = __webpack_public_path__ + "img/icon_top_signin_pre.a2004179.png";